// Script para verificar autenticación del frontend
export function checkAuthStatus() {
  console.log('🔍 VERIFICANDO AUTENTICACIÓN DEL FRONTEND...');
  
  // Verificar si hay token en localStorage
  const token = localStorage.getItem('accessToken');
  console.log('Token en localStorage:', token ? '✅ PRESENTE' : '❌ AUSENTE');
  
  if (token) {
    console.log('Token (primeros 50 chars):', token.substring(0, 50) + '...');
    
    // Verificar si el token está expirado
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const now = Math.floor(Date.now() / 1000);
      const exp = payload.exp;
      
      console.log('Token expira en:', new Date(exp * 1000).toLocaleString());
      console.log('Token válido:', now < exp ? '✅ SÍ' : '❌ NO (expirado)');
      
      if (now >= exp) {
        console.log('⚠️ TOKEN EXPIRADO - Necesita reloguearse');
        return false;
      }
    } catch (error) {
      console.log('❌ Error parseando token:', error);
      return false;
    }
  } else {
    console.log('❌ NO HAY TOKEN - Necesita loguearse');
    return false;
  }
  
  return true;
}

// Función para hacer login automático
export async function autoLogin() {
  console.log('🔐 INTENTANDO LOGIN AUTOMÁTICO...');
  
  try {
    const base = (import.meta as any).env?.VITE_API_URL || (import.meta as any).env?.VITE_API_BASE_URL || 'http://localhost:8010';
    const response = await fetch(`${base}/api/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: 'admin@sabiolab.com',
        password: 'admin123'
      })
    });
    
    console.log('📡 Respuesta del servidor:', response.status, response.statusText);
    
    if (response.ok) {
      const data = await response.json();
      console.log('✅ Login exitoso');
      console.log('Token recibido:', data.accessToken ? '✅ SÍ' : '❌ NO');
      console.log('Token (primeros 50 chars):', data.accessToken ? data.accessToken.substring(0, 50) + '...' : 'NO HAY TOKEN');
      
      if (data.accessToken) {
        localStorage.setItem('accessToken', data.accessToken);
        console.log('✅ Token guardado en localStorage');
        
        // Verificar que el token se guardó correctamente
        const savedToken = localStorage.getItem('accessToken');
        console.log('🔍 Token guardado verificado:', savedToken ? '✅ SÍ' : '❌ NO');
        
        return true;
      }
    } else {
      console.log('❌ Error en login:', response.status, response.statusText);
      const errorData = await response.text();
      console.log('Error details:', errorData);
    }
  } catch (error) {
    console.log('❌ Error de red:', error);
  }
  
  return false;
}
